/**
 * @generated SignedSource<<1c0ab20886f1d3e4f9ce5a57c7faef54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RestoreCompanyInput = {
  companyId: string;
};
export type useCompanyRestoreMutation$variables = {
  input: RestoreCompanyInput;
};
export type useCompanyRestoreMutation$data = {
  readonly restoreCompany: {
    readonly company: {
      readonly id: string;
      readonly deletedAt: any | null;
      readonly organization: {
        readonly id: string;
        readonly totalCompanies: {
          readonly totalCount: number;
        };
      } | null;
    };
  } | null;
};
export type useCompanyRestoreMutation = {
  variables: useCompanyRestoreMutation$variables;
  response: useCompanyRestoreMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RestoreCompanyPayload",
    "kind": "LinkedField",
    "name": "restoreCompany",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deletedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": "totalCompanies",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "includeDeleted",
                    "value": "NO"
                  }
                ],
                "concreteType": "CompaniesConnection",
                "kind": "LinkedField",
                "name": "companies",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  }
                ],
                "storageKey": "companies(includeDeleted:\"NO\")"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCompanyRestoreMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCompanyRestoreMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "dafc0c7345acac4b5a6609b4216deedb",
    "id": null,
    "metadata": {},
    "name": "useCompanyRestoreMutation",
    "operationKind": "mutation",
    "text": "mutation useCompanyRestoreMutation(\n  $input: RestoreCompanyInput!\n) {\n  restoreCompany(input: $input) {\n    company {\n      id\n      deletedAt\n      organization {\n        id\n        totalCompanies: companies(includeDeleted: NO) {\n          totalCount\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "31420afdb008c5ece4da7845ec4bc289";

export default node;
